import React, { useState } from "react";

function PlayerModal({ isOpen, onClose, onAddData }) {
  const [formData, setFormData] = useState({
    gamerTag: "",
    department: "",
    game: "",
    rank: ""
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    onAddData(formData);
    setFormData({
      gamerTag: "",
      department: "",
      game: "",
      rank: ""
    });
    onClose();
  }

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Register Player</h3>
        <form onSubmit={handleSubmit}>

  <div className="input-group">
    <input
      type="text"
      name="gamerTag"
      value={formData.gamerTag}
      onChange={handleChange}
      required
    />
    <label>Gamer Tag</label>
  </div>

  <div className="input-group">
    <input
      type="text"
      name="department"
      value={formData.department}
      onChange={handleChange}
      required
    />
    <label>Department (e.g., CPE)</label>
  </div>

  <div className="input-group">
    <select
      name="game"
      value={formData.game}
      onChange={handleChange}
      required
    >
      <option value=""></option>
      <option>Mobile Legends</option>
      <option>Valorant</option>
      <option>Call of Duty</option>
      <option>League of Legends</option>
    </select>
    <label>Select Game</label>
  </div>

  <div className="input-group">
    <select
      name="rank"
      value={formData.rank}
      onChange={handleChange}
      required
    >
      <option value=""></option>
      <option>Beginner</option>
      <option>Intermediate</option>
      <option>Advanced</option>
      <option>Pro</option>
    </select>
    <label>Select Rank</label>
  </div>

  <button type="submit" className="btn-submit">
    Add Player
  </button>
  <button type="button" onClick={onClose} className="btn-close">
    Cancel
  </button>

</form>
      </div>
    </div>
  );
}

export default PlayerModal;